import { render, staticRenderFns } from "./PorletHookCustom.vue?vue&type=template&id=8519bc64"
import script from "./PorletHookCustom.vue?vue&type=script&lang=js"
export * from "./PorletHookCustom.vue?vue&type=script&lang=js"
import style0 from "./PorletHookCustom.vue?vue&type=style&index=0&id=8519bc64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports